import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FiAlertTriangle, FiArrowLeft } from 'react-icons/fi';
import '../../styles/NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <Helmet>
        <title>Page Not Found | Quick Inbox</title>
        <meta name="description" content="The page you are looking for could not be found. Return to Quick Inbox to create a temporary email address." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <div className="not-found-content">
        <div className="error-icon">
          <FiAlertTriangle />
        </div>
        
        <h1>404 - Page Not Found</h1>
        
        <p className="error-message">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        
        <div className="error-suggestions">
          <p>You might want to:</p>
          <ul>
            <li>Check the URL for typing errors</li>
            <li>Return to our homepage</li>
            <li>Try one of the links below</li>
          </ul>
        </div>
        
        <div className="action-buttons">
          <Link to="/" className="home-button">
            <FiArrowLeft /> Back to Homepage
          </Link>
        </div>
        
        <div className="helpful-links">
          <h3>Quick Links</h3>
          <div className="links-grid">
            <Link to="/">Create Temp Mail</Link>
            <Link to="/blog">Blog Articles</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 